import React, { Component } from "react";
import fire from "../../config/config";
import { Table, Button, Dimmer, Loader, Modal } from "semantic-ui-react";

import * as moment from "moment";

export default class TobesentBtcAndTbc extends Component {
  state = {
    list: [],
    loading: true,
    open: false,
    confirmName: "",
    confirmPayN: 0,
    choosenP: null
  };

  componentDidMount() {
    fire
      .database()
      .ref("/duePayments")
      .on("value", snap => {
        var data = snap.val();
        var list = [];
        for (let i in data) {
          list.push({ ...data[i], key: i });
        }
        list.reverse();
        this.setState({ list, loading: false });
      });
  }

  done(p, dimmer) {
    //console.log(key);
    this.setState({
      dimmer,
      open: true,
      confirmName: p.name,
      confirmPayN: 6 - Number(p.payRemaining) + 1,
      choosenP: p
    });

    //not sure if right place
  }

  proceed() {
    const { choosenP } = this.state;
    if (+choosenP.payRemaining === 1) {
      //not done
      fire
        .database()
        .ref(`/duePayments/${choosenP.key}/`)
        .update({
          done: true,
          payRemaining: Number(choosenP.payRemaining) - 1
        })
        .then(() => this.close());
    } else {
      fire
        .database()
        .ref(`/duePayments/${choosenP.key}/`)
        .update({
          payRemaining: Number(choosenP.payRemaining) - 1
        })
        .then(() => this.close());
    }
  }

  close() {
    this.setState({ open: false });
  }

  render() {
    var { list, loading, dimmer, open, confirmPayN, confirmName } = this.state;
    //console.log(msgs);
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }
    if (list.length === 0) {
      return <div>Empty</div>;
    }
    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>TBC Address</Table.HeaderCell>
            <Table.HeaderCell>BTC Address</Table.HeaderCell>
            <Table.HeaderCell>Package Bought</Table.HeaderCell>
            <Table.HeaderCell>Bought on</Table.HeaderCell>
            <Table.HeaderCell>Payment #</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {list.map((p, index) => {
            if (!p.done) {
              return (
                <Table.Row key={index}>
                  <Table.Cell>{p.name}</Table.Cell>
                  <Table.Cell>{p.email}</Table.Cell>
                  <Table.Cell>{p.tbc_address}</Table.Cell>
                  <Table.Cell>{p.btc_address}</Table.Cell>
                  <Table.Cell>{p.package + " $"}</Table.Cell>
                  <Table.Cell>{moment(p.date).format("LLLL")}</Table.Cell>
                  <Table.Cell>{6 - Number(p.payRemaining) + 1}</Table.Cell>
                  <Table.Cell>
                    <Button onClick={() => this.done(p, "inverted")}>
                      Confirm
                    </Button>
                  </Table.Cell>
                </Table.Row>
              );
            } else return null;
          })}
        </Table.Body>

        <Modal dimmer={dimmer} open={open} onClose={() => this.close()}>
          <Modal.Header>Confirm the payment</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              Are you sure you want to confirm payment #{confirmPayN + " "}
              for {confirmName}?
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => this.close()}>
              Cancel
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Proceed"
              onClick={() => this.proceed()}
            />
          </Modal.Actions>
        </Modal>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/AdminDash/TobesentBtcAndTbc.js